// eslint-disable-next-line import/prefer-default-export
export const authGetters = {
    picture(state) {
        return state.picture
    },
    name(state) {
        return state.name
    },
    authenticated(state) {
        return state.authenticated
    },
    expiresAt(state) {
        return state.expiresAt
    },
    loginError(state) {
        return state.loginError
    },
    role(state) {
        return state.role
    }
};
